import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";

import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Cancel as CancelIcon,
  List as ListIcon,
} from "@material-ui/icons";

import { Grid, Button, Box, TextField } from "@material-ui/core";
import EditarProduto from "./Edit";
import GestaoComplementos from "./Complementos";

import * as types from "src/store/types/produtos";
import {
  pesquisarProdutos,
  excluirProduto,
  pesquisarCategorias,
  imagensProduto,
} from "src/store/actions/produtos";

import {
  Container,
  DataGrid,
  Dialog,
  FilterBar,
  InputText,
  Loading,
  Paginate,
} from "src/components";
import NumberFormat from "react-number-format";

const Produtos = () => {
  const dispatch = useDispatch();
  const {empresa_atual} = useSelector( state => state.usuario)
  const {
    produto_filtro,
    produto_page,
    produto_perpage,
    produto_total,
    produto_lista,
    loading,
    produto,
  } = useSelector((state) => state.produtos);
  const [modal, setModal] = useState({
    editar: false,
    excluir: false,
    complemento: false,
  });

  useEffect(() => {
    pesquisar();
  }, [modal]);

  const addFilter = (filtro) =>
    dispatch({ type: types.SET_FILTRO_DELIV_PRODUTO, payload: { ...filtro } });
  const changed = (e) =>
    dispatch({ type: types.SET_DELIV_PRODUTO, payload: { ...produto, ...e } });
  const modals = (value) => setModal({ ...modal, ...value });

  const limparfiltros = () => {
    addFilter({
      titulo: "",
      descricao: "",
      status: "",
      destaque: null,
      galeria_imagens: null,
    });
    dispatch(
      pesquisarProdutos({
        page: 1,
        per_page: produto_perpage,
      })
    );
  };

  const pesquisar = () => {
    dispatch([
      pesquisarCategorias({ page: 1, per_page: 1000 }),
      pesquisarProdutos({
        ...produto_filtro,
        page: produto_page,
        per_page: produto_perpage,
      }),
    ]);
  };

  const handleChangePage = (newPage) => {
    dispatch([
      { type: types.SET_PAGE_DELIV_PRODUTO, payload: newPage + 1 },
      pesquisarProdutos({
        ...produto_filtro,
        page: newPage + 1,
        per_page: produto_perpage,
      }),
    ]);
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch([
      { type: types.SET_PAGE_DELIV_PRODUTO, payload: 1 },
      {
        type: types.SET_PERPAGE_DELIV_PRODUTO,
        payload: parseInt(event.target.value, 10),
      },
      pesquisarProdutos({
        ...produto_filtro,
        page: 1,
        per_page: parseInt(event.target.value, 10),
      }),
    ]);
  };

  const excluir = () => {
    excluirProduto().then(
      () => modals({ ...modals, excluir: false }),
      (e) => console.log(e)
    );
  };

  return (
    <Container title="Produtos">
      <GestaoComplementos modal={modal} modals={modals} />
      <EditarProduto modal={modal} changed={changed} modals={modals} />
      <Loading loading={loading} />
      <Dialog
        visible={modal.excluir}
        title="Excluir"
        contenttext="Deseja realmente excluir este registro?"
        buttons={[
          {
            title: "Excluir",
            icon: <DeleteIcon />,
            onClick: () => excluir(),
            danger: true,
          },
          {
            title: "Cancelar",
            icon: <CancelIcon />,
            onClick: () => modals({ ...modals, excluir: false }),
            autofocus: true,
          },
        ]}
      />
      <Box display="flex">
        <FilterBar
          fullWidth
          searchFilter={() => pesquisar()}
          clearFilter={() => limparfiltros()}
        >
          <Grid container spacing={3}>
            <Grid item sm={6}>
              <InputText
                label="Titulo"
                value={produto_filtro.titulo}
                onChange={(event) => addFilter({ titulo: event.target.value })}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                fullWidth
                select
                label="Status"
                value={produto_filtro.status}
                onChange={(event) => addFilter({ status: event.target.value })}
                margin="dense"
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              >
                <option value=""> Todos </option>
                <option value="A"> Ativo </option>
                <option value="I"> Inativo </option>
              </TextField>
            </Grid>
            <Grid item sm={2}>
              <TextField
                fullWidth
                select
                label="Destaque"
                value={produto_filtro.destaque}
                onChange={(event) =>
                  addFilter({ destaque: event.target.value })
                }
                margin="dense"
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              >
                <option value=""> Todos </option>
                <option value="0"> Não </option>
                <option value="1"> Sim </option>
              </TextField>
            </Grid>
            <Grid item sm={2}>
              <TextField
                fullWidth
                select
                label="Imagem"
                value={produto_filtro.galeria_imagens}
                onChange={(event) =>
                  addFilter({ galeria_imagens: event.target.value })
                }
                margin="dense"
                SelectProps={{ native: true }}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              >
                <option value="">Todos</option>
                <option value="0"> Não </option>
                <option value="1">Sim</option>
              </TextField>
            </Grid>
          </Grid>
        </FilterBar>
        <Button
          size="small"
          color="primary"
          onClick={() => {
            let cashback = empresa_atual.tipo_cashback == 'F' ? empresa_atual.cashback : 0;
            dispatch([
              { type: types.SET_IMAGENS_PRODUTO, payload: [] },
              {
                type: types.SET_DELIV_PRODUTO,
                payload: { titulo: "", descricao: "", icone: "", percentual_cashback: cashback },
              },
            ]);
            modals({ ...modals, editar: true });
          }}
        >
          <AddIcon /> Novo
        </Button>
      </Box>
      <PerfectScrollbar>
        <DataGrid
          columns={[
            {
              title: "",
              render: (rowData) => {
                return rowData.imagem_id ? (
                  <img
                    src={`https://images-conexo.us-east-1.linodeobjects.com/produtos/imagens/${
                      rowData.imagem_id
                    }.png?${new Date().getMilliseconds()}`}
                    alt=""
                    style={{ width: 50, height: 50, borderRadius: 5 }}
                  />
                ) : (
                  <div style={{ width: 50, height: 50, borderRadius: 5 }}></div>
                );
              },
              width: 80,
              headerStyle: { paddingLeft: 10 },
              cellStyle: { paddingLeft: 10 },
            },
            {
              title: "Titulo",
              field: "titulo",
              headerStyle: { paddingLeft: 10 },
              cellStyle: { paddingLeft: 10, whiteSpace: "nowrap" },
            },
            {
              title: "R$ Valor",
              render: (rowData) => (
                <NumberFormat
                  prefix="R$ "
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                  fixedDecimalScale={true}
                  value={rowData.valor_atual || 0}
                  decimalScale={2}
                  style={{ color: "#373737" }}
                />
              ),
              width: 100,
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "R$ Anterior",
              render: (rowData) => (
                <NumberFormat
                  prefix="R$ "
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                  fixedDecimalScale={true}
                  value={rowData.valor_anterior || 0}
                  decimalScale={2}
                  style={{ color: "#373737" }}
                />
              ),
              width: 100,
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "% CashBack",
              field: "percentual_cashback",
              width: 100,
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "Estoq.",
              field: "quantidade_estoque",
              width: 90,
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "E. Min.",
              render: (rowData) => {
                return (
                  <span
                    style={{
                      color: rowData.alerta_estoque_min ? "#A52A2A" : "#000000",
                    }}
                  >
                    {rowData.quantidade_estoque_min}
                  </span>
                );
              },
              width: 90,
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "E. Max.",
              field: "quantidade_estoque_max",
              width: 100,
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "Qtde Compl.",
              field: "complementos",
              width: 120,
              headerStyle: { paddingLeft: 10 },
              cellStyle: { paddingLeft: 10 },
            },
            {
              title: "Status",
              field: "status",
              lookup: { A: "Ativo", I: "Inativo" },
              width: 120,
              headerStyle: { paddingLeft: 10 },
              cellStyle: { paddingLeft: 10 },
            },
          ]}
          data={produto_lista}
          options={{
            rowStyle: (rowData) => ({
              backgroundColor: rowData.destaque == 1 ? "#EEE" : "#FFF",
            }),
          }}
          actions={[
            {
              icon: () => <ListIcon color="primary" />,
              tooltip: "Complementos",
              onClick: (event, rowData) => {
                dispatch({
                  type: types.SET_DELIV_PRODUTO,
                  payload: { ...produto, ...rowData },
                });
                modals({ ...modals, complemento: true });
              },
            },
            {
              icon: () => <EditIcon color="primary" />,
              tooltip: "Editar",
              onClick: (event, rowData) => {
                dispatch([
                  imagensProduto(rowData.id),
                  {
                    type: types.SET_DELIV_PRODUTO,
                    payload: { ...produto, ...rowData },
                  },
                ]);
                modals({ ...modals, editar: true });
              },
            },
            {
              icon: () => <DeleteIcon color="primary" />,
              tooltip: "Excluir",
              onClick: (event, rowData) => {
                dispatch({
                  type: types.SET_DELIV_PRODUTO,
                  payload: { ...produto, ...rowData },
                });
                modals({ ...modals, excluir: true });
              },
            },
          ]}
        />
      </PerfectScrollbar>
      <Paginate
        rowsPerPageOptions={[5, 10, 20, 30]}
        rowsPerPage={parseInt(produto_perpage)}
        onChangeRowsPerPage={(e) => handleChangeRowsPerPage(e)}
        onChangePage={(event, newPage) => handleChangePage(newPage)}
        count={produto_total}
        page={produto_page - 1}
      />
    </Container>
  );
};

export default Produtos;
